import React from "react";
import { useMessageSource } from "react-message-source";
import TextInputField from "../formik/text-input";

export default function CompanyPosition({
  dataPath = "",
  value,
}: {
  dataPath?: string;
  value: string;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();

  return (
    <TextInputField
      name={`${dataPath}companyPosition`}
      label={getMessage("Person.companyPosition")}
      value={value}
    />
  );
}
